export type {
  ToastBodyBaseProps as ToastBodyProps,
  ToastBodyBaseState as ToastBodyState,
  ToastBodySlots,
} from '@fluentui/react-toast';
